import LinePlaneDepartureIcon from 'components/Luxkit/Icons/line/LinePlaneDepartureIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import noop from 'lib/function/noop'
import React, { useCallback } from 'react'

interface Props {
  airport: App.AirportLocation;
  onClick?: (airport: App.AirportLocation) => void;
  selected?: boolean;
}

function OfferAirportSelectOption(props: Props) {
  const { airport, onClick = noop, selected, ...rest } = props

  const onAirportSelect = useCallback(() => {
    onClick(airport)
  }, [airport, onClick])

  return <ListItem
    {...rest}
    size="large"
    startIcon={<LinePlaneDepartureIcon />}
    title={airport.airportName}
    subtitle={airport.airportCode}
    onClick={onAirportSelect}
    selected={selected}
  />
}

export default OfferAirportSelectOption
